// Ordering for categories and products. Rows with a `sort_order` (set by drag and drop in the
// admin dashboard) come first, in that order; the rest follow in the default order.

const hasPosition = (item) => item.sort_order !== null && item.sort_order !== undefined;

export const bySortOrder = (fallback) => (a, b) => {
  const aHas = hasPosition(a);
  const bHas = hasPosition(b);
  if (aHas && bHas && a.sort_order !== b.sort_order) return a.sort_order - b.sort_order;
  if (aHas !== bHas) return aHas ? -1 : 1;
  return fallback(a, b);
};

export const byName = (a, b) => (a.name || '').localeCompare(b.name || '');

// Oldest first, so products keep the order they were added in
export const byCreatedAt = (a, b) =>
  (a.created_at || '').localeCompare(b.created_at || '') || String(a.id).localeCompare(String(b.id));

export const sortCategories = (categories) => [...categories].sort(bySortOrder(byName));
export const sortProducts = (products) => [...products].sort(bySortOrder(byCreatedAt));

// Supabase error when add-sort-order.sql hasn't been run yet
export const isMissingSortOrderColumn = (error) =>
  !!error && (error.code === '42703' || error.code === 'PGRST204') && /sort_order/.test(error.message || '');

export const MISSING_SORT_ORDER_MESSAGE =
  'Ordering needs a one-time database update: run add-sort-order.sql in the Supabase SQL Editor.';
